/* global ParentBuddyChatbot */
import React, { useEffect, useState } from 'react';
import { auth, db } from '../firebase';
import { doc, getDoc, updateDoc } from 'firebase/firestore';
import { Button } from '../components/ui/button';
import { useNavigate } from 'react-router-dom';
import Confetti from 'react-confetti';
import { useWindowSize } from '@uidotdev/usehooks';
import StreakCalendar from '../components/StreakCalendar';
import '../components/StreakCalendar.css';
import toast, { Toaster } from 'react-hot-toast';
import Navbar from '../components/Navbar';
import { Link } from 'react-router-dom';
import BuddyBot from './BuddyBot';



const brainyMascot = '/mascot/brainy.gif';

const unlockables = [
  { level: 1, title: '🎉 Brainy Journey Started' },
  { level: 3, title: '🔓 New Avatar Unlocked' },
  { level: 5, title: '🚀 New Avatar Unlocked' },
  { level: 7, title: 'New Avatar Unlocked' },
  { level: 10, title: 'New Avatar Unlocked' },
  { level: 15, title: 'New Avatar Unlocked' },
  { level: 20, title: 'New Avatar Unlocked' },
  { level: 30, title: 'New Avatar Unlocked' },
  { level: 50, title: 'New Avatar Unlocked' },
  { level: 75, title: 'New Avatar Unlocked' },
  { level: 100, title: 'New Avatar Unlocked' },
];

const STREAK_MILESTONES = [7, 21, 50, 100];

export default function Home() {
  const [loading, setLoading] = useState(true);
  const { width, height } = useWindowSize();
  const [chronos, setChronos] = useState(0);
  const [userName, setUserName] = useState('');
  const [showConfetti, setShowConfetti] = useState(false);
  const [unlockedReward, setUnlockedReward] = useState(null);
  const [prevLevel, setPrevLevel] = useState(0);
  const [badges, setBadges] = useState([]);
  const [userData, setUserData] = useState(null);
  const navigate = useNavigate();
  const [isActive, setIsActive] = useState(true);
  const [streak, setStreak] = useState(0);
  const [avatar, setAvatar] = useState('');
  const [showLoginBonus, setShowLoginBonus] = useState(false);
    const [deferredPrompt, setDeferredPrompt] = useState(null);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstallClick = () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      deferredPrompt.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === 'accepted') {
          setDeferredPrompt(null);
        }
      });
    }
  };

  // 👆 End PWA Install Button State

  const level = Math.floor(chronos / 100);
  const xpToNext = 100 - (chronos % 100);
  const progressPercent = ((chronos % 100) / 100) * 100;

  const hour = new Date().getHours();
  const greeting =
    hour < 12 ? 'Good morning' : hour < 18 ? 'Good afternoon' : 'Good evening';

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      if (!user) return;

      const userRef = doc(db, 'users', user.uid);
      const snap = await getDoc(userRef);
      if (!snap.exists()) return;

      const data = snap.data();
      // 🛠 Auto-generate referralCode for legacy users
      if (!data.referralCode && data.name) {
        const cleanBase = data.name.toLowerCase().replace(/\s+/g, '');
        const suffix = Math.floor(100 + Math.random() * 900);
        const code = `${cleanBase}${suffix}`;
        await updateDoc(userRef, { referralCode: code });
        data.referralCode = code;
      }

      setUserData(data);
      setAvatar(data.avatar || '');

      const today = new Date().toDateString();
      const yesterday = new Date(Date.now() - 86400000).toDateString();

      if (data.lastLoginDate === today) {
        setStreak(data.streak || 0);
        setChronos(data.chronos || 0);
        setBadges(data.badges || []);
      } else {
        let newStreak = data.lastLoginDate === yesterday ? (data.streak || 0) + 1 : 1;
        let newChronos = (data.chronos || 0) + 3;

        const updatedBadges = [...(data.badges || [])];
        let unlocked = null;

        for (const milestone of STREAK_MILESTONES) {
          if (newStreak === milestone && !updatedBadges.includes(milestone)) {
            updatedBadges.push(milestone);
            unlocked = `${milestone}-Day Streak Badge`;
          }
        }

        await updateDoc(userRef, {
          lastLoginDate: today,
          streak: newStreak,
          chronos: newChronos,
          badges: updatedBadges,
        });

        setShowLoginBonus(true);
        setTimeout(() => setShowLoginBonus(false), 4000);
        toast.success(`🔥 Daily Login Streak! +3 Chronos for day ${newStreak}`);
        setStreak(newStreak);
        setChronos(newChronos);
        setBadges(updatedBadges);

        if (unlocked) {
          setUnlockedReward(`🏅 ${unlocked}`);
          setShowConfetti(true);
          setTimeout(() => setShowConfetti(false), 3000);
          setTimeout(() => setUnlockedReward(null), 4000);
        }
      }

      setUserName(data.name || '');
      const newLevel = Math.floor((data.chronos || 0) / 100);
      if (newLevel > prevLevel) {
        setShowConfetti(true);
        setTimeout(() => setShowConfetti(false), 3000);
        const unlock = unlockables.find((item) => item.level === newLevel);
        if (unlock) {
          setUnlockedReward(unlock.title);
          setTimeout(() => setUnlockedReward(null), 4000);
        }
      }
      setPrevLevel(newLevel);
      setIsActive(data.isActive ?? true);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading) return null;
  return (
    <>
      <Navbar />
      {deferredPrompt && (
        <button    
          className="fixed bottom-20 right-20 bg-purple-700 text-white py-2 px-6 rounded-full shadow-lg z-50"
          onClick={handleInstallClick}
        >
          📲 Install BrainyBuddy App
        </button>
      )}

      {showLoginBonus && (
        <div className="fixed top-20 left-1/2 transform -translate-x-1/2 bg-green-100 text-green-800 font-semibold px-6 py-3 rounded-full shadow-lg z-50 animate-bounce">
          🎉 Another Brainy Buddy just joined! Refer friends using your ID and earn +10 Chronos!
        </div>
      )}

      {userData?.referrerName && (
        <div className="bg-yellow-200 text-purple-800 px-4 py-2 text-center text-sm font-semibold">
          🎉 A big shout-out to <span className="text-purple-900">{userData.referrerName}</span> for inviting a new Brainy Buddy!
        </div>
      )}
      <div className="min-h-screen bg-gradient-to-br from-yellow-100 to-pink-100 flex flex-col items-center justify-center px-4 py-6">
        {auth.currentUser?.uid && (
          <div className="bg-purple-100 border border-purple-300 rounded-xl px-4 py-2 text-center text-sm font-semibold text-purple-800 mb-4">
            📣 Share your Referrer ID: <span className="text-purple-900">{userData?.referralCode || auth.currentUser.uid}</span>

            <button
              onClick={() => {
                navigator.clipboard.writeText(userData?.referralCode || auth.currentUser.uid);
                toast.success('Referrer ID copied!');
              }}
              className="ml-2 bg-purple-600 text-white px-2 py-1 rounded text-xs hover:bg-purple-700"
            >
              Copy
            </button>
          </div>
        )}
        <Toaster position="top-center" />
        {showLoginBonus && (
          <div className="fixed top-4 left-1/2 transform -translate-x-1/2 bg-yellow-300 text-purple-900 font-semibold px-6 py-3 rounded-full shadow-lg animate-bounce z-50">
            🎁 +3 Chronos — Daily Login Bonus!
          </div>
        )}
        {unlockedReward && (
          <div className="fixed top-6 left-1/2 transform -translate-x-1/2 bg-green-500 text-white px-6 py-3 rounded-xl shadow-lg z-50 animate-bounce transition-all">
            🎁 New Unlock: {unlockedReward}
          </div>
        )}

        {!isActive ? (
          <div className="max-w-xl mx-auto mt-10 text-center bg-yellow-100 p-6 rounded-xl shadow">
            <h2 className="text-2xl font-bold text-yellow-800 mb-2">Your Brainy Journey Awaits! 🌟</h2>
            <p className="text-gray-700 mb-4">Your demo period has ended. Unlock the full experience, power up your mind, and continue growing with us!</p>
            <Button onClick={() => navigate('/upgrade')} className="px-5 py-2 bg-purple-600 text-white rounded hover:bg-purple-700">
              Become a Pro Brainy 💎
            </Button>
          </div>
        ) : (
          <div className="w-full max-w-2xl bg-white/90 rounded-2xl shadow-xl p-6 text-center space-y-6">

            {/* 👋 Dynamic Greeting with Avatar */}
            <div className="flex items-center justify-between">
              <h1 className="text-4xl font-bold text-purple-800">{greeting}, {userName || 'Brainy'}! 👋</h1>
              <div className="w-16 h-16 rounded-full bg-purple-400 text-white text-xl flex items-center justify-center font-bold overflow-hidden">
                {avatar ? (
                  avatar.startsWith('/') ? <img src={avatar} alt="Avatar" className="w-full h-full object-cover rounded-full"/> : <span className="text-4xl">{avatar}</span>
                ) : userName[0]?.toUpperCase()}
              </div>
            </div>

            {/* 🎯 Daily Mission Card */}
            <div className="bg-yellow-50 border border-yellow-200 p-4 rounded-xl shadow-md">
              {/* 🎓 Brainy Welcome & Mascot Motivation */}
              <div className="mb-6 text-center space-y-3">
                <h1 className="text-2xl sm:text-3xl font-bold text-purple-800">What's NEW? 🚀</h1>
                <div className="text-md sm:text-lg text-gray-700 px-2 max-w-xl mx-auto text-left">
                  🏅 Hall of Honour — Updated for the month May.<br />
                  🧠 Your brain is your superpower! 💡 Train it to Brilliance!
                </div>
                <div className="text-md sm:text-lg text-gray-700 px-2 max-w-xl mx-auto text-right">
                  Warm regards,<br />
                  Team Brainy Buddy
                </div>
                <img src={brainyMascot} alt="Brainy Buddy Mascot" className="w-24 sm:w-28 h-24 sm:h-28 mx-auto animate-bounce" style={{ alignSelf: 'right' }}/>
              </div>
            </div>

            {/* 🧠 Chronos Info */}
            <div className="bg-purple-100 text-purple-800 font-bold text-xl px-6 py-4 rounded-xl shadow mb-6 text-center">
              <img src="/icons/C.png" alt="hourglass" className="inline w-10 h-10 ml-2 align-middle" /> Chronos: <span className="text-purple-900">{chronos}</span>
            </div>

            {/* 🚀 Level Progress */}
            <div className="w-full bg-white rounded-xl p-4 shadow text-left space-y-4">
              <h2 className="text-xl font-bold text-purple-800">Level {level} 🚀</h2>
              <div className="w-full bg-white h-4 rounded-full overflow-hidden">
                <div className="bg-purple-500 h-4" style={{ width: `${progressPercent}%` }} />
              </div>
              <p className="text-sm text-gray-600 mt-1">{xpToNext} Chronos to Level {level + 1}</p>
            </div>

            {/* 🔥 Streak Calendar */}
            <section>
              <h2 className="text-xl font-bold text-yellow-600 mb-2">🔥 Your Streak: <span className="text-orange-900">{streak}</span></h2>
              <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 bg-white border border-purple-200 rounded-xl p-4">
                {STREAK_MILESTONES.map(day => (
                  <div key={day} className="flex flex-col items-center">
                    <img src={`/assets/badges/${day}day.png`} alt={`${day}-day badge`} className={`w-16 h-16 ${streak >= day ? '' : 'grayscale blur-sm'}`} />
                    <p className="mt-1 text-sm">{streak >= day ? 'Unlocked' : `Locked (${day})`}</p>
                  </div>
                ))}
              </div>
            </section>

            {/* 🎮 Brainy Games Section */}
            <div>
              <h2 className="text-xl font-bold text-purple-700 mb-4">🧠 Your Brainy Missions</h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <button onClick={() => navigate('/game/focus')} className="p-4 bg-gradient-to-r from-pink-400 to-pink-600 text-white rounded-xl shadow-md hover:scale-105 transition-transform duration-200 font-bold text-lg">
                  🎯 Focus Game
                  <p className="text-sm font-light mt-1">Boost your attention and speed</p>
                </button>

                <button onClick={() => navigate('/game/number-memory')} className="p-4 bg-gradient-to-r from-yellow-400 to-yellow-600 text-white rounded-xl shadow-md hover:scale-105 transition-transform duration-200 font-bold text-lg">
                  🔢 Number Memory
                  <p className="text-sm font-light mt-1">Train your memory like a wizard</p>
                </button>

                <button onClick={() => navigate('/game/synonym')} className="p-4 bg-gradient-to-r from-green-400 to-green-600 text-white rounded-xl shadow-md hover:scale-105 transition-transform duration-200 font-bold text-lg">
                  📚 Synonym Sync
                  <p className="text-sm font-light mt-1">Grow your vocabulary bank</p>
                </button>

                <button onClick={() => navigate('/game/math-sprint')} className="p-4 bg-gradient-to-r from-indigo-400 to-indigo-600 text-white rounded-xl shadow-md hover:scale-105 transition-transform duration-200 font-bold text-lg">
                  ➕ Math Sprint
                  <p className="text-sm font-light mt-1">Sharpen your mental math speed</p>
                </button>

                <button onClick={() => navigate('/game/logic')} className="p-4 bg-gradient-to-r from-blue-400 to-purple-600 text-white rounded-xl shadow-md hover:scale-105 transition-transform duration-200 font-bold text-lg">
                  🧠 Logic Grid
                  <p className="text-sm font-light mt-1">Test your reasoning power</p>
                </button>

                <button onClick={() => navigate('/game/quicktap')} className="p-4 bg-gradient-to-r from-blue-400 to-purple-600 text-white rounded-xl shadow-md hover:scale-105 transition-transform duration-200 font-bold text-lg">
                  ⚡ Quick Tap
                  <p className="text-sm font-light mt-1">Test your reaction speed</p>
                </button>
              </div>
            </div>

            {/* 👨‍👩‍👧‍👦 For Parents Section */}
            <section className="mt-8 bg-white border-l-4 border-green-400 p-4 rounded-xl shadow text-left">
              <h3 className="text-lg font-bold text-green-700">👨‍👩‍👧‍👦 For Parents</h3>
              <p className="text-sm text-gray-700 mt-2">
                Every game here is backed by research to improve memory, vocabulary, and concentration.
                Encourage daily play for cognitive growth, and track their progress anytime in the profile section!
              </p>
            </section>

            {/* Chatbot Container */}
            <div className="fixed bottom-4 left-1/2 transform -translate-x-1/2 z-50">
        <Link to="/ask-buddy">
          <button className="bg-purple-600 text-white px-6 py-2 rounded-full shadow-lg transition duration-300 hover:bg-purple-700">
            Ask Buddy 🤖
          </button>
        </Link>
      </div>
      </div>
              
        )}
      </div>
    </>
  );
}
